import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as fromRoot from '@app/reducers';
import { Plan } from '@app/shared/models/plan';
import { DialogService } from '@ngneat/dialog';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Constant } from 'src/constant';
import { environment } from 'src/environments/environment';
import * as fromSignup from '../../signup/reducers';
import { DomainActionsSignup } from './actions';
import { ModalDomainCreationProcessComponent } from './modals/modal-domain-creation-process/modal-domain-creation-process.component';

@Component({
  selector: 'app-domain',
  templateUrl: './domain.component.html',
  styleUrls: ['./domain.component.scss']
})
export class DomainComponent {

  domainError$: Observable<any>;
  plan$: Observable<Plan>;
  customUrl = '';
  domainRegexp = '';
  submitted = false;
  domainForm: FormGroup;
  appDomain = environment.appDomain;

  constructor(
    private fb: FormBuilder,
    private store$: Store<fromRoot.State & fromSignup.State>,
    private dialog: DialogService
  ) {
    this.initDomainForm();
    this.domainForm.valueChanges.subscribe(changes => {
      this.customUrl = changes.domain;
      this.store$.dispatch(DomainActionsSignup.updateDomainToCreate({ domain: changes.domain }));
    });
    this.domainError$ = this.store$.pipe(select(fromSignup.getDomainError));
    this.plan$ = this.store$.select(fromRoot.getPlan);
  }

  get f() { return this.domainForm.controls; }


  private initDomainForm() {
    this.domainForm = this.fb.group({
      domain: ['', [Validators.pattern(Constant.regexpDomainCreation), Validators.required]],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.domainForm.valid) {
      this.createDomain();
    }
  }

  createDomain() {
    this.dialog.open(ModalDomainCreationProcessComponent, {
      closeButton: false,
      enableClose: false,
      size: 'sm'
    });
    this.store$.dispatch(DomainActionsSignup.createDomain());
  }

}
